<template>
  <div id="design-page">
    <ParallaxHeader :headline="'Design'" :slogan="''"/>
    <v-container fluid grid-list-xl>
      <v-layout row wrap justify-center>
        <v-flex xs12 lg8 xl6>
        <!-- <v-card flat color="grey lighten-2"> -->
          <v-tabs color="grey lighten-2" left>
            <v-tab v-for="(design, designIndex) in designData" :key="designIndex" @click="index = designIndex">
              {{ design.title }}
            </v-tab>
          </v-tabs>
          <!-- <v-container> -->
            <v-layout row wrap>
              <!-- <v-flex x12 md8 lg6> -->
              
              <!-- <v-flex x12 md8 lg6> -->
              <v-flex xs12 md6>
                <div class="design-div" dense color="grey lighten-2">
                  <h2 class="display-2">{{ designData[index].title }}<span clas="inline-buzz-hr"></span></h2>
                  <hr class="buzz-hr">
                  <p v-for="(para, i) in designData[index].content.split('\n')" :key="i" class="content-text">{{ para }}</p> 
                </div>
              </v-flex>
              <v-flex xs12 md6>
                <v-card v-if="designData[index].image">
                  <v-card-media :src="'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + designData[index].image" height="70vh">
                  </v-card-media>
                </v-card>
              </v-flex>
            </v-layout>
          <!-- </v-container> -->
          <!-- </v-card> -->
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import ParallaxHeader from '@/components/ParallaxHeader'
import Design from '@/components/Design'
import Api from '@/api'

export default {
  data () {
    return {
      designData: [{'title': '', 'content': ''}],
      index: 0
    }
  },
  components: {
    ParallaxHeader,
    Design
  },
  beforeMount () {
    this.getDesignData()
  },
  methods: {
    getDesignData () {
      const path = '/design'
      const auth = {
        username: this.authUsername,
        password: this.authPassword
      }
      Api.get(path, auth)
        .then(response => {
          if (response.data.status === 0) {
            this.designData = response.data.design
          } else {
            this.$swal(response.data.message)
          }
        })
        .catch(error => {
          this.$swal(error.toString().substring(0, 100))
        })
    }
  }
}
</script>

<style scoped>
#design-page {
  font-family: 'Lato', sans-serif;
}
#page-name {
  font-size: 3.5vmax;
  font-family: 'Vollkorn', serif;
}
.container {
  /*min-height: 58vh;*/
}
.inline-buzz-hr {
  border-top: 1px solid #ccc;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/pages/DesignsPage.vue